<template>
  <el-container style="height: 100%">
    <div>
      <el-menu
        :default-active="this.$route.path"
        class="el-menu-vertical"
        unique-opened
        router
        @select="handleselect"
        :collapse="isCollapse"
        style="overflow: auto"
      >
        <el-menu-item index="/dashboard" class="main-title">
          <i v-show="isCollapse" class="menu-title-sub">网校</i>
          <span slot="title" class="menu menu-title">新网校题库管理后台</span>
        </el-menu-item>
        <!-- <el-menu-item index="/dashboard">
          <i class="el-icon-menu"></i>
          <span slot="title" class="menu">首页</span>
        </el-menu-item> -->
        <el-submenu v-for="(menu, index) in menus" :index="index + 1 + ''" :key="menu.id">
          <template slot="title">
            <i :class="menu.icon"></i>
            <span slot="title" class="menu">{{ menu.name }}</span>
          </template>
          <el-menu-item
            @click="addCurrTabArr(submenu)"
            v-for="submenu in menu.resources"
            :index="submenu.url"
            :key="submenu.id"
          >
            <template slot="title">
              <i :class="submenu.icon"></i>
              <span slot="title" class="submenu">{{ submenu.name }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div
      v-show="tagsVisible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
      @mouseleave="leave()"
      @mouseenter="tagsVisible = true"
    >
      <!-- <div class="contextmenu_text" @click="refreshSelectedTag()">刷新页面</div> -->
      <div class="contextmenu_text" @click="closeSelectedTag()">关闭当前</div>
      <div class="contextmenu_text" @click="closeOthersTags()">关闭其他</div>
      <div class="contextmenu_text" @click="closeAllTags()">关闭所有</div>
    </div>

    <el-container>
      <el-header class="main-header" style="height: 50px">
        <div class="headerFlex">
          <div class="collapseDiv">
            <i
              class="el-icon-s-fold collapseIcon"
              @click="isCollapse = true"
              v-show="!isCollapse"
            ></i>
            <i
              class="el-icon-s-unfold collapseIcon"
              @click="isCollapse = false"
              v-show="isCollapse"
            ></i>
          </div>
          <div class="avaterDiv">
            <div>
              <el-dropdown>
                <avatar
                  class="el-dropdown-link"
                  username="123123123"
                  :src="
                    userInfo.avatar
                      ? userInfo.avatar
                      : 'https://n.sinaimg.cn/tech/transform/547/w350h197/20190902/2e6d-ieaiqii0404478.gif'
                  "
                  :size="40"
                ></avatar>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="userInfoVisible = true">
                    <i class="el-icon-user"></i>个人信息
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="logout">
                    <i class="el-icon-right"></i>退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="header-username">
              {{ userInfo.name ? userInfo.name : "Admin" }}
            </div>
          </div>
        </div>
      </el-header>
      <div class="main-tabs" @mouseleave="leave()">
        <el-tabs
          v-model="currTabValue"
          type="card"
          @tab-remove="removeTab"
          @tab-click="currTab"
          @contextmenu.prevent.native="openMenu($event)"
        >
          <el-tab-pane
            v-for="(item, index) in currTabArr"
            :key="index"
            :label="item.MenuName"
            :closable="item.URL != '/dashboard' ? true : false"
            :name="item.URL"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <el-main style="padding-top: 0px">
        <keep-alive>
          <router-view v-if="$route.meta.auth"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.auth"></router-view>
      </el-main>
    </el-container>
    <el-dialog title="修改信息" :visible.sync="userInfoVisible" width="30%" left>
      <el-form ref="userInfoForm" :model="userInfoForm" :label-width="formLabelWidth">
        <el-form-item label="头像" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :action="fileAction"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="showAvatar" :src="userInfoForm.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="重置密码" prop="password">
          <el-input
            type="password"
            v-model="userInfoForm.password"
            placeholder="请输入密码"
            auto-complete="off"
            maxlength="64"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="修改昵称" prop="name">
          <el-input
            v-model="userInfoForm.name"
            placeholder="请输入昵称"
            auto-complete="off"
            maxlength="64"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="userInfoVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateUserInfo"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import Avatar from "vue-avatar";

export default {
  components: {
    Avatar,
  },
  data() {
    return {
      tagsVisible: false,
      top: 0,
      left: 0,
      currTabValue: "",
      currTabArr: [{ MenuName: "首页", URL: "/dashboard" }],
      defaultActiveIndex: "1",
      isCollapse: false,
      formLabelWidth: "80px",
      // menus: [],
      userInfoForm: {},
      userInfo: {},
      userInfoVisible: false,
      showAvatar: false,
      fileAction: process.env.BASE_URL + "/system/uploadFile",
      imageUrl: "",
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
    };
  },
  computed: {
    menus() {
      return this.$store.state.resources;
    },
  },
  methods: {
    leave() {
      this.tagsVisible = false;
    },
    closeSelectedTag() {
      let currRouter = localStorage.getItem("lastRouter");
      this.currTabArr.forEach((item, index) => {
        if (item.URL == currRouter) {
          this.currTabArr.splice(index, 1);
          localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
          this.tagsVisible = false;
          this.$router.push({
            path: this.currTabArr[this.currTabArr.length - 1].URL,
          });
        }
      });
    },
    openMenu(e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.tagsVisible = true;
      // this.selectedTag = tag
    },
    closeOthersTags() {
      let currRouter = localStorage.getItem("lastRouter");
      let currRouterName = localStorage.getItem("lastRouterName");
      let obj = {
        MenuName: currRouterName,
        URL: currRouter,
      };
      if (currRouter == "/dashboard") {
        this.currTabArr = [];
        this.currTabArr.push(obj);
        this.tagsVisible = false;
        localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
        this.$router.push({
          path: this.currTabArr[this.currTabArr.length - 1].URL,
        });
      } else {
        this.currTabArr = [{ MenuName: "首页", URL: "/dashboard" }];
        this.currTabArr.push(obj);
        this.tagsVisible = false;
        localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
        this.$router.push({
          path: this.currTabArr[this.currTabArr.length - 1].URL,
        });
      }
    },
    closeAllTags() {
      this.currTabArr = [{ MenuName: "首页", URL: "/dashboard" }];
      localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
      this.tagsVisible = false;
      this.$router.push({
        path: this.currTabArr[this.currTabArr.length - 1].URL,
      });
    },
    //----------------处理已打开的tab-------------------------------------------------------------
    removeTab(targetUrl) {
      let tabs = this.currTabArr;
      let removeItem = (arr, item) => {
        //数组里移除指定元素
        let result = [];
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] !== item) {
            result.push(arr[i]);
          }
        }
        return result;
      };

      this.currTabArr.forEach((item, index) => {
        if (item.URL === targetUrl && targetUrl !== "/dashboard") {
          this.currTabArr = removeItem(tabs, item);
          localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
        }
      });
      if (this.currTabValue === targetUrl) {
        //如果移除的是当前已打开的tab，则给数组最后一个加上active
        this.$router.push({
          path: this.currTabArr[this.currTabArr.length - 1].URL,
        });
      }
    },
    currTab(targetName) {
      this.$router.push({ path: this.currTabValue }); //当前tab跳转
    },
    addCurrTabArr(menu) {
      let sty = true;
      this.currTabArr.forEach((item) => {
        if (menu.url == item.URL) {
          sty = false;
        }
      });
      if (sty) {
        this.currTabArr.push({ MenuName: menu.name, URL: menu.url });
      }
      localStorage.setItem("currTabArr", JSON.stringify(this.currTabArr));
    },
    handleselect(index) {
      this.$router.push({ path: index });
    },
    logout() {
      this.$store.commit("signOut");
      this.$router.push({ name: "login" });
    },
    getUserInfo() {
      this.api.getUserInfo().then((result) => {
        if (result.success) {
          this.userInfo = result.data;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    updateUserInfo() {
      this.api.updateUserInfo(this.userInfoForm).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.userInfoVisible = false;
          this.getUserInfo();
        } else {
          this.$message.error(result.message);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.userInfoForm.avatar = res.data;
      this.showAvatar = true;
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
  mounted() {
    this.getUserInfo();
    this.currTabValue = this.$route.path;
  },
  watch: {
    $route(to, from) {
      this.menus.forEach((item) => {
        if (to.path == item.url) {
          this.currTabValue = to.path;
        }
        item.resources.forEach((items) => {
          if (to.path == items.url) {
            this.currTabValue = to.path;
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.contextmenu {
  position: absolute;
  z-index: 3000;
  background: #fff;
  padding: 10px 0;
  border-radius: 4px;
  line-height: 25px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.contextmenu_text {
  cursor: pointer;
  padding: 0 15px;
}

.contextmenu_text:hover {
  background: rgb(236, 245, 255);
}
.main-side {
  background-color: #344058;
  height: 100%;
}
.main-header {
  background-color: #4d94ff;
}
.el-menu-vertical {
  max-width: 200px;
  height: 100%;
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}
.menu {
  font-size: 14px;
}
.submenu {
  font-size: 13px;
}
.main-title {
  background-color: #4d94ff !important;
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.menu-title-sub {
  color: #fff !important;
  font-size: 14px;
  font-weight: 600;
}
.collapseIcon {
  color: #eeeeee;
  font-size: 24px;
  cursor: pointer;
  height: 50px;
  line-height: 50px;
}
.collapseDiv {
  height: 50px;
  line-height: 50px;
}
.menu-title {
  font-size: 18px !important;
  font-weight: 600;
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.headerFlex {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.avaterDiv {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
.header-username {
  font-size: 16px;
  color: #fff;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue